import ValidateDocumentActionTypes from './validate-document.types'

const validateDocumentReducer = (state=null, action) => {
  
  switch (action.type) {
    case ValidateDocumentActionTypes.VALIDATE_DOCUMENT_SUCCESS:
       return {
        ...state,
        ...action.payload
       }
    default:
      return state
  }
}

export default validateDocumentReducer